"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    indexToRotation: function() {
        return indexToRotation;
    },
    rotationToIndex: function() {
        return rotationToIndex;
    }
});
function indexToRotation(n) {
    return [
        0,
        90,
        270,
        180
    ][n % 4];
}
function rotationToIndex(degree) {
    const rotationValues = [
        0,
        90,
        270,
        180
    ];
    const index = rotationValues.indexOf((360 + degree) % 360);
    return index !== -1 ? index : 0;
}
